import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserPermissionEnum } from '../models/user-permissions.enum';
import { PermissionService } from '../services/user/permission.service';

const UNKNOWN_EQUIPMENT_ID = 'unknown';

export const registeredEquipmentCardGuard: CanActivateFn = (route) => {
  const equipmentId = route.paramMap.get('deviceId');

  if (!equipmentId || equipmentId === UNKNOWN_EQUIPMENT_ID) {
    return true;
  }

  const permissionService = inject(PermissionService);
  const router = inject(Router);

  return permissionService
    .hasPermission(UserPermissionEnum.EquipmentRead)
    .pipe(
      map((hasPermission) => (hasPermission ? true : router.createUrlTree(['/no-permission']))),
    );
};
